import React, { useState, useEffect } from 'react';
import EmergencyDataView from '../components/EmergencyDataView';
import type { EmergencyHealthData } from '../types/emergency';
import './EmergencyAccess.css';

const DEMO_DATA: EmergencyHealthData = {
  demographics: {
    gender: 'Male',
    ageRange: '70-79',
    bloodType: 'AB+',
  },
  allergies: [
    { allergen: 'Peanuts', reactionType: 'Rash', severity: 'Anaphylactic' },
    { allergen: 'Grass', reactionType: 'Itchy Throat', severity: 'Mild' },
  ],
  medications: [
    { name: 'Diabetic Med', dosageFrequency: '500 mg / day' },
    { name: 'Nitroglycerin', dosageFrequency: '1 tablet / day' },
  ],
  conditions: [
    'Diabetes',
    'Coronary Artery Disease',
  ],
  surgicalHistory: [
    { procedure: 'General Medicine @ UHN', date: '02/01/2020' },
  ],
  vaccineHistory: [
    { vaccine: 'Flu Shot', date: '2025' },
  ],
  emergencyContacts: [
    { name: 'Peter P.', relationship: 'Friend', phone: '2-222-222-2222' },
  ],
  familyDoctor: {
    name: 'Dr. B. Banner',
    phone: '3-333-333-3333',
  },
};

const DEMO_PASSWORD = 'SilverScribe2025';

interface EmergencyDemoProps {
  bypassAuth?: boolean;
}

const EmergencyDemo: React.FC<EmergencyDemoProps> = ({ bypassAuth }) => {
  const [authenticated, setAuthenticated] = useState(bypassAuth || false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  // When accessed via QR code (/emergency/demo-card), silently replace the URL
  // so refreshing lands on the password-gated /emergency/demo route
  useEffect(() => {
    if (bypassAuth) {
      window.history.replaceState(null, '', '/emergency/demo');
    }
  }, [bypassAuth]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === DEMO_PASSWORD) {
      setAuthenticated(true);
    } else {
      setError('Incorrect password. Please try again.');
    }
  };

  if (!authenticated) {
    return (
      <div className="emergency-page">
        <div className="emergency-page-header">
          <img src="/Logo Trimmed.png" alt="SilverScribe" className="emergency-logo" />
          <h1>Emergency Access</h1>
        </div>
        <div className="emergency-pin-form">
          <h2>Demo Access</h2>
          <p className="form-subtitle">Enter the demo password to view sample patient data.</p>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="demo-password">Password</label>
              <input
                id="demo-password"
                type="password"
                value={password}
                onChange={(e) => { setPassword(e.target.value); setError(''); }}
                placeholder="Enter demo password"
                autoFocus
              />
            </div>
            {error && (
              <div className="emergency-error">
                <p>{error}</p>
              </div>
            )}
            <button type="submit" className="emergency-submit-btn">
              Access Demo
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="emergency-page">
      <div className="emergency-page-header">
        <img src="/Logo Trimmed.png" alt="SilverScribe" className="emergency-logo" />
        <h1>Emergency Access</h1>
      </div>
      <div className="emergency-data-container">
        <EmergencyDataView data={DEMO_DATA} isDemo />
      </div>
    </div>
  );
};

export default EmergencyDemo;
